import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Trash2 } from "lucide-react";

function ResetFiltersButton({ onClick }) {
  const classes = useStyles();
  return (
    <button className={classes.button} onClick={onClick} title="Clear all filters">
      <Trash2 className={classes.icon} />
      Reset filters
    </button>
  );
}

export default ResetFiltersButton;

const useStyles = makeStyles({
  button: {
    height: "32px",
    padding: "0 12px",
    paddingLeft: "6px",
    border: "none",
    borderRadius: "3px",
    fontSize: "16px",
    color: "rgba(12,14,41,0.8)",
    backgroundColor: "transparent",
    display: "flex",
    gap: "4px",
    alignItems: "center",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "#EDEDED",
      color: "#D84949",
    },
  },
  icon: {
    height: "16px",
    width: "16px",
    display: "block",
  },
});
